import React from "react";
import { FrontColors } from "../../../models/FrontColors";
import { FrontSpacing } from "../../../models/FrontSpacing";
import { FontQuicksand } from "../../BuildingBlocks/FontQuicksand";
import { FontSize } from "../../BuildingBlocks/FontSize";
import { SpacingRow } from "../../BuildingBlocks/SpacingRow";
import { TextColor } from "../../BuildingBlocks/TextColor";
import { WeightBold } from "../../WeightBold/WeightBold";
import { WeightSemiBold } from "../../WeightSemiBold/WeightSemiBold";
import { FrontButtonSecondarySmall } from "../../Front/Simple/FrontButtonSecondarySmall/FrontButtonSecondarySmall";

/**
 * The identity line shown to a staff member once they have picked the firm a
 * valuation belongs to.
 *
 * **When to use:** the property report form's staff branch, in place of
 * `FPPropertyReportSignedInAs`. Staff are logging on someone else's behalf, so
 * the firm has to stay on screen right up to the moment the Land Registry
 * search is bought — and stay changeable until then.
 *
 * @example
 * <FPPropertyReportLoggingOnBehalfOf
 *     introducerName="Affinion"
 *     onChange={backToPicker}
 * />
 */
export const FPPropertyReportLoggingOnBehalfOf = (props: {
    introducerName: string;
    onChange: () => void;
}): JSX.Element =>
    <SpacingRow
        justifyContent="start"
        alignItems="center"
        spacing={FrontSpacing.SMALL_2}
    >
        <TextColor color={FrontColors.NEUTRAL_18}>
            <FontQuicksand>
                <FontSize
                    size={16}
                    lineHeight={1.3}
                >
                    <WeightSemiBold>
                        Logging on behalf of <WeightBold>{props.introducerName}</WeightBold>
                    </WeightSemiBold>
                </FontSize>
            </FontQuicksand>
        </TextColor>

        <FrontButtonSecondarySmall
            label="Change"
            onClick={props.onChange}
        />
    </SpacingRow>;
